import { useDispatch, useSelector } from "react-redux";
import MainPanel from "../../components/MainPanel/MainPanel";
import DatePicker from "../../components/Misc/DatePicker";
import { useCustomSnackbar } from "../../components/Misc/useSnackbar";
import Input from "../../components/UIElements/Input";
import Select from "../../components/UIElements/Select";
import DefaultLayout from "../../layout/Layout";
import { Icon } from "@iconify/react";
import { Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { setLoading } from "../../redux/actions";
import {
  editAccount as handleEditAccount,
  deleteAccount as handleDeleteAccount,
  // getSites,
  searchAccountByID,
} from "../../service";
import MultiSelect from "../../components/UIElements/Multiselect";

const AccountDetail = () => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const [accountID, setAccountID] = useState("");
  // const [sites, setSites] = useState([]);
  const [showFilter, setShow] = useState(true);
  const [accountData, setAccount] = useState(null);
  const [isEdit, setEdit] = useState(false);
  // const [site, setSite] = useState({});
  const booleanOpt = [
    { name: "Yes", value: true },
    { name: "No", value: false },
  ];
  const [formData, setFormData] = useState({});
  useEffect(() => {
    const id = search.get("id");
    if (id) {
      setShow(false);
      searchAccount();
    }
  }, []);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.user);
  const { tags } = useSelector((state) => state.account);
  const searchAccount = async () => {
    if (search.get("id") !== "") {
      if (!accountID && !search.get("id"))
        return toast({
          type: "warning",
          message: "Input valid account ID and try again.",
        });
      dispatch(setLoading({ stat: true, text: "Searching Accounts" }));
      const { account } = await searchAccountByID(
        accountID || search.get("id")
      );
      dispatch(setLoading(false));
      setAccount(account || {});
    }
  };
  const toast = useCustomSnackbar();

  const deleteAccount = async (id) => {
    dispatch(setLoading({ stat: true, text: "Deleting Account" }));
    const { status, account } = await handleDeleteAccount(id);
    dispatch(setLoading(false));
    if (status) {
      toast({
        type: "success",
        message: `Account ID ${account?.username} has been deleted successfully.`,
      });
      setAccount(null);
      navigate("/account/list");
    } else {
      toast({
        type: "danger",
        message: "Something went wrong. please try again later.",
      });
    }
  };

  const saveAccount = async () => {
    const id = search.get("id") || accountData.id;
    dispatch(setLoading({ stat: true, text: "Saving Account" }));
    const { account, status } = await handleEditAccount({
      id,
      formData: { ...accountData, ...formData },
    });
    dispatch(setLoading(false));
    setAccount(account);
    toast({
      type: status && account ? "success" : "error",
      message:
        status && account
          ? "The account has been updated successfully."
          : "Something went wrong.",
    });
    setEdit(false);
  };
  const editAccount = async () => {
    const {
      active,
      auto_po,
      auto_po_from,
      axs_authorized,
      disable_sapi,
      disable_yapi_transfers,
      disable_zero_amount_auto_po,
      do_not_barcode,
      exclude_default_notes,
      password,
      proxy_url,
      proxy_url_enabled,
      reset_password_enabled,
      site,
      username,
      vendor_id,
      internal_tags,
      internal_notes,
      custom_notes,
      po_inventory_tags,
    } = accountData;
    setFormData({
      active,
      auto_po,
      auto_po_from,
      axs_authorized,
      disable_sapi,
      disable_yapi_transfers,
      disable_zero_amount_auto_po,
      do_not_barcode,
      exclude_default_notes,
      password,
      proxy_url,
      proxy_url_enabled,
      reset_password_enabled,
      site_id: site.id,
      username,
      vendor_id,
      internal_tags,
      internal_notes,
      custom_notes,
      po_inventory_tags,
    });
    // dispatch(setLoading(true));
    // const { status, data: sites } = await getSites();
    // dispatch(setLoading(false));
    setEdit(true);
    // if (status) {
    //   const uniqueOptionsMap = new Map();
    //   for (const option of sites) {
    //     const { description } = option;
    //     if (!uniqueOptionsMap.has(description)) {
    //       uniqueOptionsMap.set(description, option);
    //     }
    //   }
    //   const uniqueOptions = Array.from(uniqueOptionsMap.values());
    //   setSites(uniqueOptions);
    // } else {
    //   setSites([]);
    //   toast({
    //     type: "warning",
    //     message: "Can not get the sites data.",
    //   });
    // }
  };
  const handleChanage = (e) => {
    let { name, value } = e.target;
    if (value === "true") value = true;
    if (value === "false") value = false;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
  // useEffect(() => {
  //   if (account && account.site && sites.length > 0) {
  //     const findSite = sites.find((x) => x.id === account.site.id);
  //     setSite(findSite || {});
  //   }
  // }, [sites, account]);

  return (
    <DefaultLayout isLogin={false}>
      <MainPanel>
        <div className="flex flex-col h-full">
          {showFilter && (
            <div className="flex items-end">
              <div>
                <label className="mb-3 block text-black dark:text-white">
                  Default Input
                </label>
                <input
                  type="text"
                  placeholder="Default Input"
                  value={accountID}
                  onChange={(e) => {
                    setAccountID(e.target.value);
                  }}
                  className="w-100 rounded-lg border-[1.5px] border-stroke bg-transparent py-2 px-5 text-black outline-none transition focus:border-primary active:border-primary disabled:cursor-default disabled:bg-whiter dark:border-form-strokedark dark:bg-form-input dark:text-white dark:focus:border-primary"
                />
              </div>
              <Link
                to="#"
                onClick={searchAccount}
                className="inline-flex items-center justify-center gap-2.5 rounded-full bg-black py-2 px-5 text-center font-medium text-white hover:bg-opacity-90 ml-4"
              >
                <Icon icon="material-symbols:search" />
                Search By ID
              </Link>
            </div>
          )}
          {accountData && (
            <>
              {isEdit ? (
                <>
                  <div className="w-full border rounded border-gray-300 p-3">
                    <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
                      <Select
                        value={formData.auto_po}
                        name="auto_po"
                        options={[
                          { name: "Yes", value: true },
                          { name: "No", value: false },
                        ]}
                        label="Auto PO"
                        onChange={handleChanage}
                      />
                      <div className="w-full">
                        <DatePicker
                          label="Auto PO from"
                          value={formData.auto_po_from}
                          onChange={handleChanage}
                          name="auto_po_from"
                        />
                      </div>
                      <Input
                        label="Internal Notes"
                        name="internal_notes"
                        value={formData.internal_notes}
                        onChange={handleChanage}
                        disabled
                      />
                    </div>
                    {/* <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
                      <Select
                        value={formData.axs_authorized}
                        name="axs_authorized"
                        options={booleanOpt}
                        label="AXS Authorized"
                        onChange={handleChanage}
                      />
                      <Select
                        value={formData.disable_zero_amount_auto_po}
                        name="disable_zero_amount_auto_po"
                        options={booleanOpt}
                        label="Disable Zero Amount Auto PO"
                        onChange={handleChanage}
                      />
                      <Select
                        value={formData.disable_yapi_transfers}
                        name="disable_yapi_transfers"
                        options={booleanOpt}
                        label="Disable YAPI Transfers"
                        onChange={handleChanage}
                      />
                    </div>
                    <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
                      <Select
                        value={formData.disable_sapi}
                        name="disable_sapi"
                        options={booleanOpt}
                        label="Disable SAPI"
                        onChange={handleChanage}
                      />
                      <Select
                        value={formData.do_not_barcode}
                        name="do_not_barcode"
                        options={booleanOpt}
                        label="Do not Barcode"
                        onChange={handleChanage}
                      />
                      <Select
                        value={formData.exclude_default_notes}
                        name="exclude_default_notes"
                        options={booleanOpt}
                        label="Exclude Default Notes"
                        onChange={handleChanage}
                      />
                    </div> */}
                    <div className="mb-4.5 flex flex-col gap-6 xl:flex-row items-end">
                      <MultiSelect
                        value={formData.internal_tags}
                        name="internal_tags"
                        options={
                          user.role === "admin" ? tags || [] : user?.tags || []
                        }
                        label="Internal Tags"
                        onChange={handleChanage}
                      />
                      <Input
                        label="Custom Notes"
                        name="custom_notes"
                        value={formData.custom_notes}
                        onChange={handleChanage}
                      />
                      <Select
                        value={formData.po_inventory_tags}
                        name="po_inventory_tags"
                        options={(user.role === "admin"
                          ? tags || []
                          : user?.tags || []
                        ).map((x) => ({
                          name: x,
                          value: x,
                        }))}
                        label="Inventory Tags"
                        onChange={handleChanage}
                      />
                    </div>
                    <div className="mb-4.5 flex flex-col gap-6 xl:flex-row">
                      <Input
                        label="Username"
                        name="username"
                        value={formData.username}
                        onChange={handleChanage}
                      />
                      <Input
                        label="Password"
                        name="password"
                        value={formData.password}
                        onChange={handleChanage}
                      />
                      <Select
                        value={formData.reset_password_enabled}
                        name="reset_password_enabled"
                        options={booleanOpt}
                        label="Enable Reset Password"
                        onChange={handleChanage}
                      />
                    </div>
                    {/* <div className="mb-4.5 flex flex-col gap-6 xl:flex-row items-end">
                      <div className="xl:w-1/2">
                        <Select
                          value={formData.proxy_url_enabled}
                          name="proxy_url_enabled"
                          options={booleanOpt}
                          label="Use Proxy"
                          onChange={handleChanage}
                        />
                      </div>
                      <Input
                        label="Proxy URL"
                        name="proxy_url"
                        placeholder="https://www.proxy.com"
                        value={formData.proxy_url || ""}
                        onChange={handleChanage}
                        disabled={!formData.proxy_url_enabled}
                      />
                    </div> */}
                    <div className="mb-4.5 flex flex-col gap-6 xl:flex-row items-end">
                      <Input
                        label="Vendor ID"
                        name="vendor_id"
                        placeholder="Vendor ID"
                        value={formData.vendor_id || ""}
                        onChange={handleChanage}
                        disabled
                      />
                      <div className="w-full"></div>
                      <div className="w-full flex items-center mt-4">
                        <div className="ml-auto">
                          <button
                            className="inline-flex rounded border border-[#DC3545] py-1 px-2 text-sm font-medium text-[#DC3545] hover:opacity-80"
                            onClick={() => setEdit(false)}
                          >
                            Cancel
                          </button>
                        </div>
                        <div className="ml-4">
                          <button
                            className="inline-flex rounded border border-success py-1 px-2 text-sm font-medium text-success hover:opacity-80"
                            onClick={saveAccount}
                          >
                            Save
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="w-full border rounded border-gray-300 p-3 mt-5">
                    <Typography variant="h5" gutterBottom>
                      Account Detail
                    </Typography>
                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <Typography variant="body1">
                          <strong>Username:</strong> {accountData.username}
                        </Typography>
                        <Typography variant="body1">
                          <strong>Password:</strong> {accountData.password}
                        </Typography>
                        <Typography variant="body1">
                          <strong>Company ID:</strong> {accountData.company_id}
                        </Typography>
                        <Typography variant="body1">
                          <strong>Site:</strong> {accountData.site.site}
                        </Typography>
                      </div>
                      <div>
                        <Typography variant="body1">
                          <strong>Active:</strong>{" "}
                          {accountData.active ? "Yes" : "No"}
                        </Typography>
                        <Typography variant="body1">
                          <strong>Auto Created:</strong>{" "}
                          {accountData.auto_created ? "Yes" : "No"}
                        </Typography>
                        <Typography variant="body1">
                          <strong>Disable SAPI:</strong>{" "}
                          {accountData.disable_sapi ? "Yes" : "No"}
                        </Typography>
                        <Typography variant="body1" className="mt-4">
                          <strong>Custom Notes:</strong>{" "}
                          {accountData.custom_notes}
                        </Typography>
                      </div>
                    </div>
                  </div>
                  <div className="w-full flex items-center mt-4">
                    <div className="ml-auto">
                      <button
                        className="inline-flex rounded border border-[#DC3545] py-1 px-2 text-sm font-medium text-[#DC3545] hover:opacity-80"
                        onClick={() => deleteAccount(accountData.id)}
                      >
                        Delete Account
                      </button>
                    </div>
                    <div className="ml-4">
                      <button
                        className="inline-flex rounded border border-[#F9C107] py-1 px-2 text-sm font-medium text-[#F9C107] hover:opacity-80"
                        onClick={editAccount}
                      >
                        Edit Account
                      </button>
                    </div>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </MainPanel>
    </DefaultLayout>
  );
};

export default AccountDetail;
